import HorizontalBarChart from "./horizontalBarChart.component";

export default HorizontalBarChart;